import { type Balances } from "@/entities/balance";
import { User } from "@/entities/user";

export interface Worker {
  login: string;
  balances: Balances;
  totalTurnover: number;
  totalLeadsCount: number;
  closedLeadsCount: number;
  tgId: string | null;
  lastLeadEnterAt: Date | null;
  _id: string;
  activeCommissionExclusionsCount: number;
  user: User;
}

export interface WorkerV2 {
  _id: string;
  closedLeadsCount: number;
  createdAt: string;
  isAnonymousModeEnabled: boolean;
  isFree: boolean;
  lastLeadEnterAt: string;
  lastPush: string;
  profitAlias: string;
  pushCount: number;
  totalLeadsCount: number;
  totalProfit: number;
  updatedAt: string;
  userId: string;
  activeCommissionExclusionsCount: number;

  // TODO: ПРОВЕРИТЬ В ОСТАЛЬНЫХ
  balances?: Balances;
  user?: User & { tgId?: string };
}

export interface WorkerCommissionExclusion {
  id: string;
  workerId: string;
  status: WorkerCommissionExclusionStatus;
  reason: WorkerCommissionExclusionReason;
  comment?: string;
  createdAt: string;
  updatedAt: string;
}

export enum WorkerCommissionExclusionStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum WorkerCommissionExclusionReason {
  CLAN_MEMBER = "clan_member",
  OTHER = "other",
}

export interface MarchGiveawayTicket {
  workerId: string;
  workerUsername: string;
  type?: MarchGiveawayTicketType;
  createdAt: Date;
}

export interface MarchGiveawayStats {
  workerId: string;
  leadsCreatedCount: number;
}

export enum MarchGiveawayTicketType {
  Silver = "silver",
  Diamond = "diamond",
}
